module.exports = __webpack_public_path__ + "static/assets/0afbb0f07784444372a78add998b61e0.svg";